import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

// Components
import Search from '../../searches/Search';
import SearchResults from '../../searches/Search/SearchResults';
import MemberCardRedesign from '@molecules/MemberCardRedesign/MemberCardRedesign';
import MemberListItemRedesign from '@molecules/MemberListItemRedesign/MemberListItemRedesign';
import { BodyLarge, ButtonLink, DivWithShadowAlternate } from '@styled';

// Functionality
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';
import useMembersLikeMeFilterString from '../../../hooks/useMembersLikeMeFilterString';
import { SAVED_CONTACTS_RECORD_ID_QUERY } from '@general/graphql/contact.graph';
import { mapSearchMemberToProps } from '@general/transforms/member.transform';
import useAuthorized from '@hooks/useAuthorized';
import useMemberFull from '@hooks/useMemberFull';

const SearchContainerStyled = styled(DivWithShadowAlternate)`
    padding: 32px;
`;

const MemberSearchSimiliar = ({ graphID }) => {
    const { isMemberActive } = useAuthorized();
    const { data: memberData } = useMemberFull(graphID);
    const { filterString } = useMembersLikeMeFilterString({ member: memberData });

    if (!filterString || !memberData) return null;

    return (
        <SearchContainerStyled>
            {!isMemberActive && (
                <div>
                    <BodyLarge className="mb-1rem">You must be an active member to see Listed Properties.</BodyLarge>

                    <div className="d-flex">
                        <ButtonLink
                            href="/membership/start"
                            onClick={e => {
                                e.preventDefault();
                                window.location.href = '/membership/start';
                            }}
                        >
                            Join Now
                        </ButtonLink>
                    </div>
                </div>
            )}

            {isMemberActive && (
                <SearchModeContext.Provider value={{ showFilters: false }}>
                    <Search
                        filters={filterString}
                        index="members"
                        defaultViewType="card"
                        displaySearchBox={false}
                        displaySearchOptions={false}
                        displayPagingToolbar={false}
                        hitsPerPage={4}
                        maxWidth="auto"
                    >
                        <SearchResults
                            listItemComponent={MemberListItemRedesign}
                            cardComponent={MemberCardRedesign}
                            query={SAVED_CONTACTS_RECORD_ID_QUERY}
                            resultsPerRow={2}
                            transformFunc={mapSearchMemberToProps}
                            typePlural="contacts"
                            index="members"
                        />
                    </Search>
                </SearchModeContext.Provider>
            )}
        </SearchContainerStyled>
    );
};
MemberSearchSimiliar.propTypes = {
    graphID: PropTypes.string,
};

export default MemberSearchSimiliar;
